import axios from "axios";

// Si estás con CRA, esto conviene más que import.meta.env
const RAW_BASE_URL =
  process.env.REACT_APP_API || "https://backsanpancracio.us-3.evennode.com";

const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");
const API = axios.create({ baseURL: BASE_URL });

const p = (s) => String(s || "").replace(/^\/+/, "");

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- GASTOS ----

export const getGastos = async () => {
  const { data } = await API.get(p("gastos"), auth());
  return data;
};

export const getGastoById = async (id) => {
  const { data } = await API.get(p(`gastos/${id}`), auth());
  return data;
};

export const postGasto = async (payload) => {
  const { data } = await API.post(p("gastos"), payload, auth());
  return data;
};

export const putGasto = async (id, payload) => {
  const { data } = await API.put(p(`gastos/${id}`), payload, auth());
  return data;
};

export const deleteGasto = async (id) => {
  const { data } = await API.delete(p(`gastos/${id}`), auth());
  return data;
};